import { createContext } from 'react';

export interface CampusFeatureFlags {
  hasEv?: boolean;
  hasBattery?: boolean;
  hasThermalZones?: boolean;
  hasSolar?: boolean;
  hasSingleGX?: boolean;
  notAnEms?: boolean;
}

export interface TimeRange {
  startTime: string | null;
  endTime: string | null;
}

export interface ControlMode {
  id: string;
  mode: string;
  isActive: boolean;
  untilDesc?: string;
  details?: string;
  duration?: TimeRange;
}

export interface ThermalZoneTactic {
  blockCode: string;
  endDateTime: string;
  startDateTime: string;
}

export interface ThermalZoneStatusValue {
  key: string;
  label: string;
  cssClass: string;
}

export interface ThermalZoneSummary {
  thermalZoneEntityKey: string;
  name: string;
  buildingEntityKey: string;
  buildingName: string;
  status: ThermalZoneStatusValue | null;
  activeControlStrategy: ControlMode | null;
}

export interface CampusData {
  evData?: any;
  batteryData?: any;
  thermalZoneData?: any;
  solarData?: any;
}

export interface CampusRecentEntities {
  campusId: string;
  buildingId: string;
  gxId: string;
  zoneId: string;
}

export interface CampusContextType {
  meta: {
    campusName: string;
    campusId: string;
    timezone: string;
  };
  featureFlags: CampusFeatureFlags;
  controlModes?: ControlMode[];
  thermalZones?: ThermalZoneSummary[];
  campusData?: any;
  recentEntities: CampusRecentEntities;
}

const defaultFeatureFlags: CampusFeatureFlags = {};

export const defaultCampusContext: CampusContextType = {
  meta: {
    campusName: '',
    campusId: '',
    timezone: '',
  },
  featureFlags: defaultFeatureFlags,
  controlModes: [],
  thermalZones: [],
  recentEntities: { campusId: '', buildingId: '', gxId: '', zoneId: '' },
};

export const CampusContext = createContext<CampusContextType | undefined>(undefined);
